/**
 *  Arquivo responsável por guardar o estado do componente
 *          disciplinas
 */
export default {
    qualification: []
}